export const createTokenInput = (form: HTMLFormElement): HTMLInputElement => {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'token';
  input.id = 'ctoken';
  form.appendChild(input);

  return input;
};
